module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"delete":"Delete"},"de":{"delete":"Löschen"}}')
  delete Component.options._Ctor
}
